export default __webpack_public_path__ + "static/media/press_4.322f525e.jpg";